import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

require('./PurchaseOrdersOverviewPage.less');

const PurchaseOrdersOverviewPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/supplier/purchaseOrders/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
		{
			key: 'orders',
			name: 'Order List',
		},
	];

	return (
		<>
			<Route
				path="/supplier/purchaseOrders/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/purchaseOrders/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Purchase Orders"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="purchaseOrdersPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(PurchaseOrdersOverviewPage)
);
